export type QuickSightDashboardType = {
  name: string;
  id: string;
  updated_at: string;
  thumbnail_ref?: string;
  last_manually_refreshed_at?: string | null;
};

export type QuickSightDashboardDetailType = {
  embed_url: string;
  dashboard: QuickSightDashboardType;
};

export type QuickSightSessionsType = {
  embedUrl: string;
};

export const DashboardRefreshResults = {
  SUCCESS: "success",
  FAILURE: "failure",
} as const;

/** @see DashboardRefreshResults */
export type DashboardRefreshResultType =
  (typeof DashboardRefreshResults)[keyof typeof DashboardRefreshResults];

export const DashboardRefreshFailureReasons = {
  COOLDOWN_ACTIVE: "cooldown_active",
  GENERAL_FAILURE: "general_failure",
} as const;

/** @see DashboardRefreshFailureReasons */
export type DashboardRefreshFailureReasonType =
  (typeof DashboardRefreshFailureReasons)[keyof typeof DashboardRefreshFailureReasons];

export type DashboardRefreshTriggerResultType =
  | { result: typeof DashboardRefreshResults.SUCCESS }
  | {
      result: typeof DashboardRefreshResults.FAILURE;
      reason: DashboardRefreshFailureReasonType;
      retryAfterSeconds?: number;
    };
